import Rules from 'diagram-js/lib/features/rules';

export default {
  __depends__: [ Rules ]
};